module.exports = __webpack_public_path__ + "img/bhxh.9df94fad.png";